'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

require('./navigation.scss');

var _navigationListItem = require('./navigation-list-item');

var _navigationListItem2 = _interopRequireDefault(_navigationListItem);

var _icon = require('../icon/icon');

var _icon2 = _interopRequireDefault(_icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function renderChildren(children) {
  if (!children) {
    return null;
  }

  return _react2.default.createElement(
    'li',
    null,
    _react2.default.createElement(
      'ul',
      { className: 'navigation-list__item-wrapper' },
      children
    )
  );
}

function NavigationList(props) {
  var isNavigationListCollapseClasses = props.open ? 'navigation-list--open' : '';
  var navigationListClasses = 'navigation-list ' + isNavigationListCollapseClasses;

  return _react2.default.createElement(
    'ul',
    { className: navigationListClasses },
    _react2.default.createElement(
      'li',
      { className: 'navigation-list__title', onClick: props.onClick },
      _react2.default.createElement(_icon2.default, { name: props.icon, size: props.iconSize, className: 'navigation-list__icon' }),
      props.title
    ),
    renderChildren(props.children)
  );
}

NavigationList.propTypes = {
  children: _propTypes2.default.arrayOf(_navigationListItem2.default),
  icon: _propTypes2.default.string,
  title: _propTypes2.default.string,
  open: _propTypes2.default.bool,
  onClick: _propTypes2.default.func,
  iconSize: _propTypes2.default.string
};

NavigationList.defaultProps = {
  iconSize: '22'
};

exports.default = NavigationList;